import React, { createContext, useContext, useEffect, useState } from 'react';

interface AuthContextType {
  token: string | null;
  login(token: string): void;
  logout(): void;
}
const AuthContext = createContext<AuthContextType>({ token: null, login: () => {}, logout: () => {} });

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('token'));
  const login  = (t: string) => { setToken(t); localStorage.setItem('token', t); };
  const logout = () => { setToken(null); localStorage.removeItem('token'); };

  useEffect(() => {
    const handler = () => logout();
    window.addEventListener('force-logout', handler);
    return () => window.removeEventListener('force-logout', handler);
  }, []);

  return <AuthContext.Provider value={{ token, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
